import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnvironmentService } from 'src/app/services/environment.service';
import { TechnicalSpecificationsFormSections, UICollectionTypes } from '../../../entities/enums/ui-collection-types.enum';
import { BaseTechnicalSectionComponent } from '../../common/base-technical-section.component';
import { ENERGY_TYPES } from '../../../constants/grid-application-constants';
import { detectDecimalSeparator } from '../../../utils/utils';
import { ElectricalGenerator } from '../../../entities/electricalGenerator';
import { IntegratedGridProtectionDocument } from '../../../entities/integratedGridProtectionDocument';
import { GridApplicationCommentsService } from 'src/app/+grid-application-shared/services/grid-application-comments.service';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-eproducer-data',
  styleUrls: ['./eproducer-data.component.scss'],
  templateUrl: './eproducer-data.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class EproducerDataComponent extends BaseTechnicalSectionComponent {
  @Input() isIntegratedGridProtection: boolean;
  @Output() warningsVisible = new EventEmitter<boolean>();

  public readonly UI_COLLECTION_TYPES = UICollectionTypes;
  public readonly detectDecimalSeparator = detectDecimalSeparator;

  generatorsPowerNotEqual: boolean;

  constructor(commentService: GridApplicationCommentsService, environmentService: EnvironmentService) {
    super(commentService, environmentService);
  }

  public showEnergyProducerDataSection(): boolean {
    return this.technicalData.existing_energy_producers[0].energy_type > ENERGY_TYPES.STORAGE;
  }

  public addGenerator() {
    this.technicalData.generators.push(new ElectricalGenerator());
    this.calculatePowerDifference();

    this.addGridProtectionDoc(UICollectionTypes.Generator);
  }

  public removeGenerator(event: any): void {
    const index = this.technicalData.generators.indexOf(event.element);
    this.technicalData.generators = this.technicalData.generators.filter(x => x !== event.element);
    this.calculatePowerDifference();

    this.removeGridProtectionDoc(index, event.type);
  }

  public calculatePowerDifference() {
    const total = this.technicalData.generators.reduce(
      (value, generator) => value + generator.identical_units * generator.max_unit_power,
      0
    );

    this.generatorsPowerNotEqual = total !== this.technicalData.total_power_generators;
    this.warningsVisible.emit(this.generatorsPowerNotEqual);
  }

  get formSection(): TechnicalSpecificationsFormSections {
    return TechnicalSpecificationsFormSections.DetailedInfoEnergyProducer;
  }

  protected get sectionComment(): string | null {
    return this.technicalData.technical_specifications_sections_state?.detailed_info_energy_producer_comment;
  }

  protected set sectionComment(value: string | null) {
    this.technicalData.technical_specifications_sections_state.detailed_info_energy_producer_comment = value;
  }

  protected get sectionLocked(): boolean | null {
    return this.technicalData.technical_specifications_sections_state?.is_detailed_info_energy_producer_locked;
  }

  protected set sectionLocked(value: boolean | null) {
    this.technicalData.technical_specifications_sections_state.is_detailed_info_energy_producer_locked = value;
  }

  // TODO : This would probably be moved in base, but stays here for now
  private addGridProtectionDoc(documentType: string): void {
    if (this.isIntegratedGridProtection) {
      this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.push(
        new IntegratedGridProtectionDocument(documentType)
      );
    }
  }

  private removeGridProtectionDoc(index: number, unitType: string): void {
    if (this.isIntegratedGridProtection) {
      const documentsToFilter = this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.filter(
        d => d.unit_type === unitType
      );

      this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents =
        this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.filter(d => d.unit_type !== unitType);

      documentsToFilter.splice(index, 1);

      this.technicalData.grid_power_plant_protection_data.integrated_grid_protection_documents.push(...documentsToFilter);
    }
  }
}
